/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ParticipationSummaryDto
 */
export interface ParticipationSummaryDto {
    /**
     * Participation ID
     * @type {string}
     * @memberof ParticipationSummaryDto
     */
    'id': string;
    /**
     * Challenge category ID
     * @type {string}
     * @memberof ParticipationSummaryDto
     */
    'challengeCategoryId': string;
    /**
     * User ID
     * @type {string}
     * @memberof ParticipationSummaryDto
     */
    'userId': string;
    /**
     * Delivery address ID for finisher items
     * @type {string}
     * @memberof ParticipationSummaryDto
     */
    'deliveryAddressId': string;
    /**
     * Total distance covered by the user in this challenge category in meters
     * @type {number}
     * @memberof ParticipationSummaryDto
     */
    'totalDistanceCovered': number;
    /**
     * Finisher shirt size selected by the user
     * @type {string}
     * @memberof ParticipationSummaryDto
     */
    'finisherShirtSize': string;
    /**
     * Participation status
     * @type {string}
     * @memberof ParticipationSummaryDto
     */
    'status': ParticipationSummaryDtoStatusEnum;
    /**
     * Payment status
     * @type {string}
     * @memberof ParticipationSummaryDto
     */
    'paymentStatus': ParticipationSummaryDtoPaymentStatusEnum;
    /**
     * Payment amount in the local currency
     * @type {number}
     * @memberof ParticipationSummaryDto
     */
    'paymentAmount': number;
    /**
     * Price type for this participation
     * @type {string}
     * @memberof ParticipationSummaryDto
     */
    'priceType': ParticipationSummaryDtoPriceTypeEnum;
    /**
     * Whether participant chose to include finisher shirt
     * @type {boolean}
     * @memberof ParticipationSummaryDto
     */
    'shouldIncludeFinisherShirt': boolean;
    /**
     * Whether participant chose to include medal
     * @type {boolean}
     * @memberof ParticipationSummaryDto
     */
    'shouldIncludeMedal': boolean;
    /**
     * Payment amount for finisher shirt when optional
     * @type {number}
     * @memberof ParticipationSummaryDto
     */
    'finisherShirtPaymentAmount': number;
    /**
     * Payment amount for medal when optional
     * @type {number}
     * @memberof ParticipationSummaryDto
     */
    'medalPaymentAmount': number;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof ParticipationSummaryDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof ParticipationSummaryDto
     */
    'updatedAt': string;
}

export const ParticipationSummaryDtoStatusEnum = {
    Ongoing: 'ongoing',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;

export type ParticipationSummaryDtoStatusEnum = typeof ParticipationSummaryDtoStatusEnum[keyof typeof ParticipationSummaryDtoStatusEnum];
export const ParticipationSummaryDtoPaymentStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Expired: 'expired'
} as const;

export type ParticipationSummaryDtoPaymentStatusEnum = typeof ParticipationSummaryDtoPaymentStatusEnum[keyof typeof ParticipationSummaryDtoPaymentStatusEnum];
export const ParticipationSummaryDtoPriceTypeEnum = {
    Regular: 'regular',
    EarlyBird: 'early_bird',
    Free: 'free'
} as const;

export type ParticipationSummaryDtoPriceTypeEnum = typeof ParticipationSummaryDtoPriceTypeEnum[keyof typeof ParticipationSummaryDtoPriceTypeEnum];


